import type { TubingsQueryVariables, Tubings_Bool_Exp } from "gql/api";
import { Order_By } from "gql/api";

export function restoreTubings(arr: Array<string>): Tubings_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteTubings(arr: Array<string>): Tubings_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultTubingVars: TubingsQueryVariables = {
  order_by: [{ outer_diameter_inches: Order_By.Asc }]
};

export const adminTubingVars: TubingsQueryVariables = {
  order_by: [{ outer_diameter_inches: Order_By.Asc }]
};

export const kocTubingVars: TubingsQueryVariables = {
  order_by: [{ outer_diameter_inches: Order_By.Asc }],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};
export const ecopetrolTubingVars: TubingsQueryVariables = {
  order_by: [{ outer_diameter_inches: Order_By.Asc }],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
